import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		textAlign: 'center',
	},
	hiddenCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		margin: `${THEME.spacing.sm}px 0 0`,
	},
	icon: {
		flexShrink: 0,
	},
	marker: {
		alignItems: 'baseline',
		background: THEME.colors.danger.light,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexWrap: 'wrap',
		gap: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
	},
	markerList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		listStyle: 'none',
		margin: `${THEME.spacing.md}px 0 0`,
		maxHeight: 260,
		overflowY: 'auto',
		padding: 0,
	},
	markerLocation: {
		color: THEME.colors.danger.dark,
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.semibold,
		textTransform: 'uppercase',
	},
	markerText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		// Markers are arbitrary client copy, so a long one has to wrap rather than widen the dialog
		overflowWrap: 'anywhere',
	},
	popup: {
		maxWidth: 560,
	},
	title: {
		fontSize: THEME.typography.fontSizes.lg,
	},
});
